import React, { useEffect, useState } from 'react';
import { getAvatarUrl, isRemoteAvatar } from '../utils/avatar';

const SIZES = {
  xs: 'w-7 h-7 text-[11px]',
  sm: 'w-8 h-8 text-sm',
  md: 'w-11 h-11 text-base',
  lg: 'w-16 h-16 text-xl',
  xl: 'w-28 h-28 sm:w-32 sm:h-32 text-3xl',
};

export default function UserAvatar({
  user,
  size = 'md',
  version,
  previewUrl,
  className = '',
  rounded = 'full',
}) {
  const [failed, setFailed] = useState(false);
  const src = previewUrl || getAvatarUrl(user?.avatar, version);
  const letter = user?.name?.charAt(0)?.toUpperCase() || 'U';
  const radius = rounded === '2xl' ? 'rounded-2xl' : 'rounded-full';

  useEffect(() => {
    setFailed(false);
  }, [src]);

  return (
    <div
      className={`${SIZES[size] || SIZES.md} ${radius} overflow-hidden shrink-0 flex items-center justify-center bg-[#1F80FF] text-white font-semibold ${className}`}
    >
      {src && !failed ? (
        <img
          src={src}
          alt={user?.name || 'Avatar'}
          className="w-full h-full object-cover"
          referrerPolicy={isRemoteAvatar(user?.avatar) && !previewUrl ? 'no-referrer' : undefined}
          onError={() => setFailed(true)}
        />
      ) : (
        <span>{letter}</span>
      )}
    </div>
  );
}
